var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0386 2.40467C13.0386 1.75485 13.8773 1.42289 14.3811 1.87329L18.4178 5.48193L18.4198 5.48371C18.8752 5.90028 18.8752 6.58566 18.4198 7.00223L18.4169 7.00487L14.3828 10.6326C13.8796 11.0851 13.0386 10.7536 13.0386 10.1027V8.58343C10.4175 8.58343 7.66488 8.98065 6.23258 11.731C6.13549 11.9175 5.81664 11.8492 5.83261 11.6397C6.31871 5.25896 10.8853 4.28469 13.0386 3.92618V2.40467Z",
    fill: "#555893"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.8425 2.4668C2.70401 2.4668 1.78125 3.38974 1.78125 4.52811V15.646C1.78125 16.7844 2.70413 17.7073 3.84257 17.7073H14.9605C16.0989 17.7073 17.0218 16.7844 17.0218 15.646V12.4503C17.0218 11.9941 16.652 11.6243 16.1958 11.6243C15.7396 11.6243 15.3698 11.9941 15.3698 12.4503V15.646C15.3698 15.8721 15.1865 16.0553 14.9605 16.0553H3.84257C3.6165 16.0553 3.43324 15.8721 3.43324 15.646V4.52811C3.43324 4.302 3.61649 4.11879 3.8425 4.11879H8.79789C9.25408 4.11879 9.62389 3.74898 9.62389 3.29279C9.62389 2.83661 9.25408 2.4668 8.79789 2.4668H3.8425Z",
    fill: "#555893"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.7bbb300a.svg";
export { ForwardRef as ReactComponent };